var formatUserAnswer = function (_a) {
    var nextQuestionId = _a.nextQuestionId, answerId = _a.answerId, currentQuestion = _a.currentQuestion, option = _a.option, disputeReason = _a.disputeReason, _b = _a.isEligibleForPartialAmount, isEligibleForPartialAmount = _b === void 0 ? false : _b, script = _a.script, type = _a.type;
    return {
        nextQuestionId: nextQuestionId,
        id: currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id,
        questionText: currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.questionText,
        answers: option,
        answerId: answerId,
        disputeReason: disputeReason,
        isEligibleForPartialAmount: isEligibleForPartialAmount,
        script: script,
        type: type
    };
};
export default formatUserAnswer;
//# sourceMappingURL=formatUserAnswer.js.map